// Hook odpowiedzialny za pobranie listy zwrotów i reklamacji

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse,
  ISearchRequest,
  IStatus
} from 'api/types';

export interface IReturnsComplaintsListItem {
  lp: number;
  id: number;
  description: string;
  status: number;
  status_name: string;
  status_data: IStatus | null;
  return_complain_reason_id: number;
  reason_name: string;
  return_complain_type_id: number;
  type_name: string;
  product_name: string;
  product_code: string
  request_date: string;
  is_editable?: boolean;
  is_cancelable?: boolean;
}

// parametry requestu do api
export type IRequest = IPaginationRequest & ISearchRequest;

// typ zwracanych danych
type IResponse = IPaginationResponse<IReturnsComplaintsListItem>;

const getReturnsComplaints = (params?: IRequest): Promise<IResponse> => axios.get('/return-complain', { params });

export const useGetReturnsComplaints = (params?: IRequest, options?: UseQueryOptions<IResponse, IError>) =>
  useQuery<IResponse, IError>(['return-complain', params], () => getReturnsComplaints(params), options)
